import type { SVGProps } from "react";
import * as React from "react";

const SvgAirplay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 18a1 1 0 1 0 0-2zm-3-3H1zM4 3V2zm16 0V2zm-1 13a1 1 0 1 0 0 2zm-7-1 .768-.64a1 1 0 0 0-1.536 0zm5 6v1a1 1 0 0 0 .768-1.64zM7 21l-.768-.64A1 1 0 0 0 7 22zm-2-5H4v2h1zm-1 0a1 1 0 0 1-.707-.293l-1.414 1.414A3 3 0 0 0 4 18zm-.707-.293A1 1 0 0 1 3 15H1a3 3 0 0 0 .879 2.121zM3 15V5H1v10zM3 5a1 1 0 0 1 .293-.707L1.879 2.879A3 3 0 0 0 1 5zm.293-.707A1 1 0 0 1 4 4V2a3 3 0 0 0-2.121.879zM4 4h16V2H4zm16 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 20 2zm.707.293A1 1 0 0 1 21 5h2a3 3 0 0 0-.879-2.121zM21 5v10h2V5zm0 10a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 23 15zm-.293.707A1 1 0 0 1 20 16v2a3 3 0 0 0 2.121-.879zM20 16h-1v2h1zm-8.768-.36 5 6 1.536-1.28-5-6zM17 20H7v2h10zm-9.232 1.64 5-6-1.536-1.28-5 6z"
    />
  </svg>
);
export default SvgAirplay;
